import "./styles/Admin.css"
import React, { FC, useEffect, useState } from "react"
import AdminUser from "./user/AdminUser"
import AdminAsset from "./asset/AdminAsset"
import AdminUserModalsContainer from "./user/AdminUserModalsContainer"
import { useSearchParams } from "react-router-dom"

export enum AdminUserAssetTabOptions {
  USER = 1,
  ASSET = 2
}
const AdminUserAsset: FC = () => {
  const [params, setParams] = useSearchParams()
  const [tab, setTab] = useState<number>(() =>
    params.has("user_id") ? AdminUserAssetTabOptions.ASSET : AdminUserAssetTabOptions.USER
  )

  useEffect(() => {
    setTab(params.has("user_id") ? AdminUserAssetTabOptions.ASSET : AdminUserAssetTabOptions.USER)
  }, [params])

  const [modalOption, setModalOption] = useState<number | undefined>(undefined)

  return (
    <div className="admin flex relative">
      <div className="w-full absolute left-0 top-0 right-0">
        {tab === AdminUserAssetTabOptions.USER ? (
          <AdminUser
            tab={tab}
            setTab={setTab}
            modalOption={modalOption}
            setModalOption={setModalOption}
            params={params}
            setParams={setParams}
          />
        ) : (
          <AdminAsset
            tab={tab}
            setTab={setTab}
            modalOption={modalOption}
            setModalOption={setModalOption}
            params={params}
            setParams={setParams}
          />
        )}
      </div>

      <AdminUserModalsContainer modalOption={modalOption} setModalOption={setModalOption} />
    </div>
  )
}

export default AdminUserAsset
